import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo, useState } from 'react';
import { useMediaQueries } from '@honda-canada/design-system-react';
import Context from './Context';
import safelyStringifyJSON from '../../../utils/safelyStringifyJSON';
import useConfiguration from './useConfiguration';
import useProductFinancial from '../../../apiHooks/useProductFinancial';
import { getId } from './utils';
const TrimSpecificationsConfigurationProvider = ({ children, variant, vehicleType, appNameConfig, }) => {
    const config = useConfiguration(variant);
    const [currentSlide, setCurrentSlide] = useState(0);
    const [slidePerPage, setSlidePerPage] = useState(5);
    const [selectedTrim, setSelectedTrim] = useState();
    const { setModels, financial, hasError, isFetching } = useProductFinancial({ vehicleType });
    const productFinancial = financial;
    const { isSmallDesktop, isDesktop } = useMediaQueries();
    const isMobile = !(isSmallDesktop || isDesktop);
    const perPage = isMobile ? 1 : slidePerPage;
    const splideOptions = {
        perPage,
        pagination: false,
        arrows: false,
        start: currentSlide,
    };
    const contextValue = useMemo(() => ({
        variant,
        vehicleType,
        ...config,
        ...appNameConfig,
        slidePerPage,
        setSlidePerPage,
        selectedTrim,
        setSelectedTrim,
        currentSlide,
        setCurrentSlide,
        splideOptions,
        isMobile,
        setModels,
        financial: productFinancial,
        hasError,
        isFetching,
        getItemId: getId,
    }), [
        variant,
        slidePerPage,
        selectedTrim,
        currentSlide,
        perPage,
        isMobile,
        safelyStringifyJSON(config),
        safelyStringifyJSON(appNameConfig),
        safelyStringifyJSON(productFinancial),
        hasError,
        isFetching,
        getId,
    ]);
    return _jsx(Context.Provider, { value: contextValue, children: children });
};
export default TrimSpecificationsConfigurationProvider;
